import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import ClickableListItem from 'LuxKit/List/ClickableListItem'
import Typography from 'LuxKit/Typography/Typography'
import { GlobalSearchDispatchContext, GlobalSearchStateContext } from 'contexts/GlobalSearch/GlobalSearchContexts'
import { GlobalSearchStateActions } from 'contexts/GlobalSearch/GlobalSearchState'
import { rem } from 'polished'
import { useCallback, useContext } from 'react'
import * as React from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import LineCompassIcon from 'LuxKit/Icons/line/LineCompassIcon'
import { without } from 'lib/array/arrayUtils'
import CheckboxButton from 'LuxKit/Checkbox/CheckboxButton'

const Divider = styled.hr`
  height: 1px;
  position: relative;
  border: none;
  margin-bottom: 0;
  overflow: visible;

  &::before {
    content: '';
    position: absolute;
    left: ${rem(-8)};
    right: ${rem(-8)};
    height: 1px;
    background-color: ${props => props.theme.palette.neutral.default.six};
  }
`

interface Props {
  groupTypes: Array<App.Tours.TourItemGroupType>
}

function TourV2SearchGroupItems(props: Props) {
  const { groupTypes } = props
  const intl = useIntl()
  const { tourGroupTypes = [] } = useContext(GlobalSearchStateContext)
  const searchDispatch = useContext(GlobalSearchDispatchContext)

  const toggleTourGroupType = useCallback((e: React.MouseEvent<HTMLButtonElement>) => {
    const groupId = e.currentTarget.dataset.groupid as App.Tours.TourGroupType
    const newTourGroupTypes = tourGroupTypes?.includes(groupId) ? without(tourGroupTypes, groupId) : [...tourGroupTypes, groupId]
    searchDispatch({
      type: GlobalSearchStateActions.SET_TOUR_GROUP_TYPE,
      tourGroupTypes: newTourGroupTypes,
    })
  }, [searchDispatch, tourGroupTypes])

  const onSelectAllGroup = useCallback(() => {
    searchDispatch({ type: GlobalSearchStateActions.SELECT_ALL_TOUR_GROUP_TYPE })
  }, [searchDispatch])

  return <VerticalSpacer gap={8}>
    <ClickableListItem
      title={intl.formatMessage({
        id: 'ohc4WqYGzxMmhPnMK2kX',
        defaultMessage: 'All group types',
        description: 'Title for selecting all tour group types option on the form',
      })}
      subtitle={intl.formatMessage({
        id: 'IPxMSGca1kiaN49UDcrj',
        defaultMessage: 'Inspire me with all ways to travel',
        description: 'Subtitle for selecting all tour group types option',
      })}
      startIcon={<LineCompassIcon />}
      onClick={onSelectAllGroup}
      type="submit"
    />
    <Divider />
    {groupTypes.map(group => <ClickableListItem
      key={group.id}
      title={group.name}
      subtitle={<Typography>{group.subtitle}</Typography>}
      data-groupid={group.id}
      startIcon={group.icon}
      endIcon={<CheckboxButton
        data-testid={group.id}
        checked={tourGroupTypes?.includes(group.id)}
        size="large"
      />}
      onClick={toggleTourGroupType}
    />)}
  </VerticalSpacer>
}

export default TourV2SearchGroupItems
